import Validation from "@/validation/Validation";

class ApplicationValidation extends Validation {
    static getCustomErrorMessages() {
        return {
            custom: {
                ApplicationName: {
                    required: 'The Name is required',
                },
                app_type: {
                    required: 'The Application Type is required',
                },
            }
        }
    }
}

export default ApplicationValidation;
